<template>
    <div class="" style="margin-left: 75px;" v-resize="onResize">
        <!-- site dialog -->
        <d-site
            v-model  = "unit.show"
            :site-id = "unit.id"
            :edit    = "unit.edit"
            @saved   = "onUnitSaved"
            @type    = "onUnitType"
        />
        <!-- site dialog -->

        <d-inspection-assign-unit
            v-model     = "showAssign"
            :inspection = "order.inspection"
            @assigned   = "onAssigned"
        />

        <p-inspection-report
            v-model= "showReport"
            :order = "order.selected"
        />

        <c-app-bar
            :title         = "$t('disposition.title')"
            :categories    = "[]"
            :enable-search = "false"
            @home          = "onHome"
        >
            <template v-slot:search>
                <div
                    v-if  = "isDisponent || isDispatcher"
                    class = "ml-4 mr-1"
                    style = "margin-top: 0;"
                >
                    <f-dispatcher-select
                        v-model   = "user"
                        :dense    = "true"
                        :outlined = "true"
                    />
                </div>

                <div
                    v-if="isRestrictedDispatcher && !isDisponent && !isDispatcher"
                    class = "primary--text lm-border disposition-user"
                >
                    {{ currentUser }}
                </div>

                <div class="v-flex" style="margin-top: -3px">
                    <c-toolbar-button
                        icon     = "mdi-home"
                        color    = "primary"
                        :size    = "22"
                        :tooltip = "$t('home.button')"
                        class    = "ml-2"
                        @click   = "onHome"
                    />
                </div>

                <div class="ml-2" v-if="isDisponent || isDisponent || isRestrictedDispatcher">
                    <p-disposition-buttons
                        :user       = "user"
                        @assign     = "onAssignOn"
                        @dispatch   = "onDispatchOn"
                        @all-orders = "onAllOrdersOn"
                        @map        = "onMapOn"
                        ref         = "dispositionButtons"
                    />
                </div>

                <div class="ml-3 mt-1" v-if="order.selected.id">
                    <c-fab-menu
                        icon     = "mdi-history"
                        :menu    = "user ? download.menu.technician : download.menu.order"
                        @entry   = "onDownload"
                    />
                </div>

                <div class="ml-3 mt-1" v-if="user && !order.selected.id">
                    <c-fab-menu
                        icon     = "mdi-history"
                        :menu    = "download.menu.technician"
                        @entry   = "onDownload"
                    />
                </div>

                <v-spacer />
            </template>
        </c-app-bar>

        <div style="margin-right: 70px">
            <v-row class="no-frame top-line">
                <v-col class="no-frame order-col col-3"  v-show="!modes.allOrders">
                    <p-order-card-iterator
                        class     = "mt-1"
                        @selected = "onSelected"
                    />
                </v-col>

                <v-col class="no-frame order-col col-6 pt-1" v-show="modes.allOrders">
                    <p-disposition-location-card-iterator
                        class         = "w-100"
                        :title        = "inspectionTitle"
                        :data         = "allOrders.data"
                        :user         = "user"
                        :selected     = "unit.selected"
                        :assign-on    = "modes.assign"
                        :dispatch-on  = "modes.dispatch"
                        :all          = "true"
                        @site         = "onUnit"
                        @selected     = "onUnitSelected"
                        @new-site     = "onNewUnit"
                        @refresh      = "onRefreshInspections"
                        @filtered     = "onUnitsFiltered"
                        @locate       = "onLocate"
                        ref           = "allUnitIterator"
                    />
                </v-col>

                <v-col class="no-frame unit-col  col-3 pl-3 pt-1" v-show="!modes.allOrders">
                    <p-disposition-location-card-iterator
                        class         = "w-100"
                        :title        = "inspectionTitle"
                        :order        = "order.selected"
                        :data         = "order.data"
                        :user         = "user"
                        :loading      = "order.loading"
                        :selected     = "unit.selected"
                        :assign-on    = "modes.assign"
                        :dispatch-on  = "modes.dispatch"
                        :all          = "false"
                        @site         = "onUnit"
                        @selected     = "onUnitSelected"
                        @new-site     = "onNewUnit"
                        @refresh      = "onRefreshInspections"
                        @filtered     = "onUnitsFiltered"
                        @locate       = "onLocate"
                        ref           = "unitIterator"
                    />
                </v-col>

                <v-col class="no-frame col-6 pa-3 pr-0" style="position: relative">
                    <!-- map -->
                    <div
                        v-if="modes.map"
                        class="disposition-map"
                    >
                        <c-inspection-map
                            :order        = "order.selected"
                            :technician   = "user"
                            :assignments  = "modes.allOrders ? assignments : order.data.assignments"
                            :filteredSites = "filteredSites"
                            @selected = "onMapSelected"
                            ref       = "map"
                        />
                    </div>
                    <!-- map -->

                    <c-column-header
                        :label = "$t('disposition.order.unit.title') + ' ' + location"
                        class  = "primary text--white"
                    >
                        <template v-slot:pre>
                            <div style="margin-top: -2px; margin-right: 8px;">
                                <c-inspection-menu
                                    :inspection = "inspection"
                                    @menu       = "onMenu"
                                />
                            </div>
                        </template>

                        <template v-slot:post>
                            <p-inspection-messages
                                v-if="inspection && inspection.messages && inspection.messages.length > 0"
                                :messages = "inspection.messages"
                            />
                        </template>

                        <template v-slot:toolbar>
                            <div
                                class = "mr-1 v-flex"
                                style = "margin-top: -2px"
                            >
                                <c-toolbar-button
                                    v-if     = "isDone"
                                    color    = "white"
                                    size     = "22"
                                    icon     = "mdi-lock-open"
                                    :tooltip = "$t('disposition.inspection.reopen.tooltip')"
                                    @click   = "onReopen"
                                    class    = "mr-1"
                                />

                                <c-toolbar-button
                                    v-if     = "isNewUnit"
                                    color    = "white"
                                    size     = "24"
                                    icon     = "mdi-elevator-passenger"
                                    :tooltip = "$t('disposition.inspection.tooltip.assign')"
                                    @click   = "onAssign"
                                    class    = "mr-1"
                                />

                                <c-toolbar-button
                                    v-if     = "isNewUnit"
                                    color    = "white"
                                    size     = "24"
                                    icon     = "mdi-plus"
                                    :tooltip = "$t('disposition.inspection.tooltip.create')"
                                    @click   = "onCreate"
                                />

                                <c-toolbar-button
                                    v-if     = "order.inspection"
                                    color    = "white"
                                    size     = "20"
                                    icon     = "mdi-refresh"
                                    :tooltip = "$t('disposition.unit.refresh')"
                                    @click   = "onRefresh"
                                />
                            </div>
                        </template>
                    </c-column-header>

                    <!-- device type conflict of the app (HCIT-943) -->
                    <p-inspection-device-type-conflict
                        v-if        = "order.inspection"
                        :inspection = "order.inspection"
                        :checking   = "deviceTypeChecking"
                        @unit       = "onUnit"
                        @check      = "onCheckDeviceType"
                    />

                    <c-inspection
                        v-if        = "order.inspection"
                        :inspection = "order.inspection"
                        :height     = "height"
                        :area       = "area"
                        ref         = "disposition"
                        @refresh    = "onRefresh"
                        @technician = "onTechnician"
                        @saved      = "onInspectionSaved"
                        @menu       = "onMenu"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import Core                         from "@/modules/core/service/Core";
import Disposition                  from "@/modules/dis/service/Disposition";
import DSite                        from "@/modules/msd/unit/components/dialog/DSite.vue";
import POrderCardIterator           from "@/modules/dis/components/order/overview/POrderCardIterator.vue";
import CColumnHeader                from "@/modules/core/components/utils/CColumnHeader.vue";
import CInspection                  from "@/modules/dis/components/inspection/CInspection.vue";
import PDispositionLocationCardIterator from "@/modules/dis/components/order/location/PDispositionLocationCardIterator.vue";
import CToolbarButton               from "@/modules/core/components/utils/CToolbarButton.vue";
import CInspectionMenu              from "@/modules/dis/components/inspection/CInspectionMenu.vue";
import CAppBar                      from "@/modules/core/components/app/CAppBar.vue";
import FDispatcherSelect            from "@/modules/dis/components/inspection/common/components/FDispatcherSelect.vue";
import DInspectionAssignUnit        from "@/modules/dis/components/inspection/DInspectionAssignUnit.vue";
import CFabMenu                     from "@/modules/core/components/utils/CFabMenu.vue";
import CInspectionMap               from "@/modules/dis/components/map/CInspectionMap.vue";
import DispositionSecurityMixin     from "@/modules/dis/mixins/DispositionSecurityMixin";
import PDispositionButtons          from "@/modules/dis/components/order/common/PDispositionButtons.vue";
import PInspectionMessages from "@/modules/dis/components/order/common/PInspectionMessages.vue";
import PInspectionDeviceTypeConflict from "@/modules/dis/components/inspection/PInspectionDeviceTypeConflict.vue";
import DeviceTypeConflict           from "@/modules/dis/service/inspection/DeviceTypeConflict";
import PInspectionReport from "@/modules/dis/components/order/overview/private/PInspectionReport.vue";

export default {
    name: "MDisposition",
    components: {
        PInspectionDeviceTypeConflict,
        PInspectionReport,
        PInspectionMessages,
        PDispositionButtons,
        CInspectionMap,
        CFabMenu,
        DInspectionAssignUnit,
        FDispatcherSelect,
        CAppBar,
        CInspectionMenu,
        CToolbarButton,
        PDispositionLocationCardIterator,
        CInspection,
        CColumnHeader,
        POrderCardIterator,
        DSite
    },

    mixins: [
        DispositionSecurityMixin
    ],

    data: () => ({
        modes: {
            assign   : false,
            dispatch : false,
            allOrders: false,
            map      : false,
        },

        user: null,
        assignMode: false,
        showAssign: false,
        showReport: false,
        deviceTypeChecking: false,
        height: null,
        search: null,
        area: null,
        filteredSites: null,

        unit: {
            show: false,
            edit: false,
            id  : null,
            selected: null,
        },

        order: {
            inspection: null,
            selected: {
                customer: null,
            },

            data: {
                units: [],
                assignments: [],
            },

            loading: false,
        },

        allOrders: {
            data: {
                units: [],
                assignments: [],
            },
        },

        download: {
            menu: {
                order: [
                    { id: 1, name: "Budget Datei erstellen", icon: "mdi-file-excel-box-outline" },
                    { id: 3, name: "GBU/TZB Dokumente exportieren", icon: "mdi-file-pdf-box-outline" }
                ],
                technician: [
                    { id: 4, name: "ICS Datei vollständig erstellen" , icon: "mdi-calendar-blank"},
                    { id: 5, name: "ICS Datei nur mit neuen Terminen erstellen" , icon: "mdi-calendar-blank"},
                ]
            }
        }
    }),

    computed: {
        currentUser () {
            return Core.security.profile().name;
        },

        inspectionTitle () {
            if (this.modes.allOrders) {
                return  "Begehungen - alle Aufträge"
            }

            if (this.order.selected && this.order.selected.id) {
                if (!this.assignMode) {
                    return "Begehungen - " + (this.order.selected.no.length > 20 ? this.order.selected.no.substr(0,20) : this.order.selected.no);
                }

                return "Adressen - " + this.order.selected.customer.name.length > 20 ? this.order.selected.customer.name.substr(0,20) : this.order.selected.customer.name;
            }

            return "Bitte Auftrag auswählen";
        },

        areas () {
            return Disposition.inspection.areas
        },

        inspection () {
            if (!this.order) {
                return null;
            }

            return this.order.inspection;
        },

        isNewUnit () {
            if (!this.inspection) {
                return false;
            }

            return !this.inspection.unitId;
        },

        isDone () {
            if (!this.inspection) {
                return false;
            }

            return this.inspection.done;
        },


        location () {
            if (!this.inspection) {
                return "";
            }

            const inspection = this.order.inspection;
            let location = "";
            if (inspection.country) {
                location += inspection.country + "-";
            }

            if (inspection.zip) {
                location += inspection.zip + " ";
            }

            if (inspection.city) {
                location += inspection.city;
            }

            if (inspection.street) {
                location += ", " + inspection.street;
            }

            return location;
        },

        assignments () {
            return this.$store.getters.assignments;
        }
    },

    created: function () {
        /*
        Disposition.inspection.findAll().then (assignments => {
            this.$store.dispatch("setAssignments", assignments)
        });

         */
    },

    mounted() {
        if (this.isRestrictedDispatcher && !this.isDisponent && !this.isDispatcher) {
            const ident = Core.security.profile().username;
            const dispatcher = this.$store.getters.msd.dispatcher;
            this.user = dispatcher.find (d => d.ident === ident);
        }
    },

    methods: {
        onResize () {
            this.height = window.innerHeight;
        },

        onHome () {
            Core.nav.home(this);
        },
        
        onUnitsFiltered (filteredUnits) {
            this.filteredSites = filteredUnits;
        },

        onDispatchOn (value) {
            this.modes.dispatch = value;
        },

        onAssignOn (value) {
            this.modes.assign = value;
            this.assignMode = this.modes.assign;
        },

        onMapOn (value) {
            this.modes.map = value;
        },

        /**
         * Toggles the state of "all orders mode" and fetches necessary order and assignment data if enabled.
         *
         * @param {boolean} value Indicates whether to enable or disable "all orders mode".
         * @return {void} Does not return a value; updates the internal state and fetches data as needed.
         */
        onAllOrdersOn (value) {
            if (!value) {
                this.modes.allOrders = false;
                return;
            }

            Core.loading(this, true);
            Disposition.inspection.findAll().then (data => {
                this.$store.dispatch("setAssignments", data.assignments).then(() => {
                    /*
                    const units = [];

                    this.assignments.forEach(assignment => {
                        const unit = assignment.unit;
                        unit.inspectionId    = assignment.id;
                        unit.inspectionDate  = assignment.inspectionDate;
                        unit.download        = assignment.download;
                        unit.technicianId    = assignment.technicianId;
                        unit.technicianIdent = assignment.technicianIdent;
                        unit.technicianName  = assignment.technicianName;
                        unit.order           = assignment.order;
                        unit.done            = assignment.done;
                        units.push(unit);
                    });

                     */

                    this.allOrders.data = {
                        units: data.units,
                        assignments: this.assignments,
                    }

                    Core.loading(this, false);
                    this.modes.allOrders = true;
                })
            });
        },

        onDownload (entry) {
            switch (entry.id) {
                case 1:
                    this.downloadBudget();
                    break;
                case 3:
                    this.onDownloadDocuments ();
                    break;
                case 4:
                    this.onDownloadIcs (false);
                    break;
                case 5:
                    this.onDownloadIcs (true);
                    break;

            }
        },

        onUnit (unit) {
            this.unit.edit = false;
            this.unit.show = true;
            this.unit.id   = unit.id;
        },

        onNewUnit (unit) {
            this.unit.show = true;
            this.unit.edit = true;
            this.unit.id   = unit.id;
        },

        onRefreshInspections (callback) {
            this.order.loading = true;
            Disposition.inspection.findByOrder(this.order.selected).then(data => {
                console.log("onRefreshInspections: ", data)
                this.order.data = data;
                this.order.loading = false;
                if (callback) callback ();
            });
        },

        onAssign () {
            this.showAssign = true;
        },

        onAssigned (inspection) {
            this.onRefreshInspections(() => {
                this.$nextTick().then (() => {
                    this.onMapSelected(inspection.unitId);
                    Disposition.inspection.getById(inspection.order, inspection.id).then(inspection => {
                        this.order.inspection = inspection;
                    });
                });
            });
        },

        onReopen () {
            Core.message.confirm(
                this,
                this.$t('disposition.inspection.reopen.query'),
                this.$t('disposition.inspection.reopen.text'),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Disposition.inspection.reopen(this.order.inspection).then(inspection => {
                            this.order.inspection = inspection;
                        })
                    }
                })
        },

        onCreate () {
            Core.message.confirm(
                this,
                this.$t('disposition.unit.create.query'),
                this.$t('disposition.unit.create.text'),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Disposition.inspection.createUnit(this.order.inspection).then(inspection => {
                            this.onRefreshInspections(() => {
                                this.$nextTick().then (() => {
                                    this.onMapSelected(inspection.unitId);
                                    Disposition.inspection.getById(inspection.order, inspection.id).then(inspection => {
                                        this.order.inspection = inspection;
                                    });
                                });
                            });
                        })
                    }
                })
        },

        onSelected (order) {
            this.order.selected = order;
            this.order.inspection = null;
            this.area = null;

            if (!order.customer) {
                this.order.data = {
                    units: [],
                    assignments: [],
                }

                return;
            }

            this.onRefreshInspections();
        },

        onRefresh () {
            Disposition.inspection.getById(this.order.selected, this.unit.selected.inspectionId).then(inspection => {
                this.order.inspection = inspection;
         //       this.area = "CONTACTS";
                Core.message.hint(this, this.$t('disposition.unit.refreshDone'))
            });
        },

        onTechnician () {
            if (!this.order.inspection) {
                return;
            }

            this.$refs.unitIterator.setTechnician(this.order.inspection)
            this.$refs.allUnitIterator.setTechnician(this.order.inspection)
        },

        onInspectionSaved (inspection) {
            const assignment = this.assignments.find (a => a.id === inspection.id);
            if (assignment) {
                assignment.comment = inspection.comment;
            }
        },

        onUnitSelected (event) {
            this.unit.selected = event.unit;
            if (!event.assignment) {
                if (event.unit.done) {
                    Disposition.inspection.get(event.unit.order, event.unit).then(inspection => {
                        this.order.inspection = inspection;
                    });

                    return;
                }

                this.order.inspection = null;
                return;
            }

            this.$refs.dispositionButtons.closeMap();
            Disposition.inspection.getById(event.assignment.order, event.assignment.id).then(inspection => {
                this.order.inspection = inspection;
            });
        },

        onMapSelected (unitId) {
            if (!unitId) {
                return;
            }

            if (this.modes.allOrders) {
                this.unit.selected = this.$refs.allUnitIterator.scrollTo(unitId);
            } else {
                this.unit.selected = this.$refs.unitIterator.scrollTo(unitId);
            }
        },

        onLocate (coords) {
            if (this.$refs.map) {
                this.$refs.map.centerOn(coords);
            }
        },

        onUnitSaved () {

        },

        /**
         * The site type was changed in the unit dialog: an inspection of this unit with a device type conflict is
         * checked again, so a corrected type clears the conflict (HCIT-943).
         */
        onUnitType (site) {
            const inspection = this.order.inspection;
            if (!site || !inspection || !inspection.unit || inspection.unit.id !== site.id
                    || !DeviceTypeConflict.isOpen(inspection)) {
                return;
            }

            this.onCheckDeviceType();
        },

        /** Checks the device type of the shown inspection against the site type again (HCIT-943). */
        onCheckDeviceType () {
            const inspection = this.order.inspection;
            if (!inspection || this.deviceTypeChecking) {
                return;
            }

            this.deviceTypeChecking = true;
            Disposition.inspection.checkDeviceType(inspection).then(data => {
                this.order.inspection = data;
                this.setDeviceTypeConflict(data);
                Core.message.hint(this, this.$t(data.deviceTypeConflict
                    ? 'disposition.inspection.deviceType.conflict.stillOpen'
                    : 'disposition.inspection.deviceType.conflict.resolved'));
            }).catch(error => {
                // 409 disposition.inspection.deviceType.check.failed: masterdata-svc not reachable, nothing changed
                if (error && error.id) {
                    Core.message.popup(this, error.id, null);
                }
            }).finally(() => {
                this.deviceTypeChecking = false;
            });
        },

        /**
         * Updates the conflict flag and the error marker (messages) of the inspection in the lists (cards and filter)
         * without reloading them.
         */
        setDeviceTypeConflict (inspection) {
            const conflict = inspection.deviceTypeConflict;
            const hasErrors = !!inspection.messages && inspection.messages.length > 0;
            const assignments = [ this.assignments, this.order.data.assignments, this.allOrders.data.assignments ];
            assignments.forEach(list => (list || []).filter(a => a.id === inspection.id).forEach(assignment => {
                assignment.deviceTypeConflict = conflict;
                assignment.hasErrors = hasErrors;
                if (assignment.unit) {
                    assignment.unit.deviceTypeConflict = conflict;
                }
            }));

            const units = [ this.order.data.units, this.allOrders.data.units ];
            units.forEach(list => (list || []).filter(u => u.inspectionId === inspection.id).forEach(unit => {
                unit.deviceTypeConflict = conflict;
            }));

            if (this.unit.selected && this.unit.selected.inspectionId === inspection.id) {
                this.unit.selected.deviceTypeConflict = conflict;
            }
        },

        onMenu (entry) {
            this.area = entry.id;
        },

        downloadBudget () {
            if (!this.order.selected) {
                return;
            }

            Disposition.budget.download(this.order.selected.id).then (() => {
                Core.message.alert.save(this);
            });
        },

        onDownloadDocuments () {
            this.showReport = true;
        },

        onDownloadIcs (delta) {
            if (!this.user) {
                return;
            }

            Disposition.ics.download(this.user.ident, delta).then (() => {
                Core.message.alert.save(this);
            });
        },

        expandAll () {
            if (this.modes.allOrders) {
                this.$refs.allUnitIterator.onExpandAll();
            } else {
                this.$refs.unitIterator.onExpandAll();
            }
        }
    }
}
</script>

<style scoped>

.top-line {
    border-top-style: solid;
    border-top-color: lightgray;
    border-top-width: 1px;
    margin-top: 4px!important;
}

.order-col {
    border-right-style: solid;
    border-right-width: 1px;
    border-right-color: lightgray;
    min-height: 690px;
}

.unit-col {
    border-right-style: solid;
    border-right-width: 1px;
    border-right-color: lightgray;
    min-height: 690px;
}

.disposition-user {
    margin-top: 0;
    margin-left: 16px;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 16px;
    font-weight: 500;
    height: 34px;
    width: 180px;
    padding-top: 4px;
}

.disposition-map {
    position: absolute;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    background-color: white;
    z-index: 100;
}

::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 36px!important;
}


</style>